import { createSelector } from 'reselect';
import moment from 'moment';
import groupBy from 'lodash/groupBy';
import { PermissionsService } from 'shared/services';

const getSubjects = (state) => state.statics.emailSubjects;
const getAssignedEvents = (state) => state.users.currentUser.testCenterEventPersonnels;
const getUserEvents = (state) => state.email.userEvents;

const filterByRole = (userEvents) => {
  if (!userEvents.length) {
    return [];
  }
  return userEvents.filter((event) => event.role);
};

const filterEventsByRole = (allEvents, userAssignments) => {
  if (!allEvents.length) {
    return [];
  }
  let filteredGroupedEvents = [];
  allEvents.forEach((ev) => {
    if (PermissionsService.hasTestCenterManage(ev[0].testCenterCycle.id)) {
      filteredGroupedEvents.push(ev);
    } else {
      const filteredEvents = ev.filter((elem) =>
        userAssignments.some((event) => event.testCenterEventId === elem.id)
      );
      if (filteredEvents.length > 0) {
        filteredGroupedEvents.push(filteredEvents);
      }
    }
  });
  return filteredGroupedEvents;
};

const filterDate = (date) => {
  const futureMonths = moment().add(6, 'M');
  const pastMonths = moment().subtract(6, 'M');

  return moment(date) < futureMonths && moment(date) > pastMonths;
};

export const getUserMappedEvents = createSelector(
  [getUserEvents, getAssignedEvents],
  (allEvents, assignedEv) => {
    const mappedEvents = Object.values(
      groupBy(allEvents, (elem) => elem.testCenterCycle.testCenterProgram.testCenter.id)
    );
    const events = filterEventsByRole(mappedEvents, filterByRole(assignedEv));
    return events;
  }
);

export const getMappedTestCenters = createSelector([getUserMappedEvents], (userEvents) => {
  const mappedByTc = [];

  userEvents.forEach((tcEvent) => {
    const testCenter = {
      ...tcEvent[0].testCenterCycle.testCenterProgram.testCenter,
      testCenterId: tcEvent[0].testCenterCycle.testCenterProgram.testCenter.id,
      events: [],
    };
    tcEvent.forEach((ev) => {
      if (filterDate(ev.testingEvent.endTestDate || ev.testingEvent.testDate)) {
        testCenter.events.push({ id: ev.id, testingEvent: ev.testingEvent });
      }
    });
    mappedByTc.push(testCenter);
  });

  return mappedByTc;
});

export const mapTcOptions = createSelector([getMappedTestCenters], (mappedTc) => {
  const options = [
    {
      value: -1,
      label: 'N/A', // Will be translated in the component
    },
  ];
  mappedTc.forEach((element, idx) => options.push({ value: idx.toString(), label: element.name }));

  return options;
});

export const mapEmailSubjects = createSelector([getSubjects], (emailSubjects) => {
  emailSubjects.map((element) => ({ value: element, label: element }));

  return emailSubjects;
});
